/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as deviceV1 from "./keyapis_device_device_v1.pb"

/**
 * Сервис реализует функционал управления трубками аналоговых трубок
 */

/**
 * Сервис трубок аналоговых трубок
 */
export class CmsPhoneServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения аналоговой трубки по идентификатору.
   * Метод доступен для: admin, service, owner, employee, bti, ltp_first
   */
  GetCmsPhone = (req: GetCmsPhoneRequestDto, init?: RequestInit): Promise<GetCmsPhoneResponseDto> => {
    return fm.request<GetCmsPhoneRequestDto, GetCmsPhoneResponseDto>(`${this.host}/device/api/v1/cms_phone/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка аналоговых трубок.
   * Метод доступен для: admin, service, owner, employee, bti, ltp_first
   */
  GetCmsPhoneList = (req?: GetCmsPhoneListRequestDto, init?: RequestInit): Promise<GetCmsPhoneListResponseDto[]> => {
    return fm.list<GetCmsPhoneListRequestDto, GetCmsPhoneListResponseDto>(`${this.host}/device/api/v1/cms_phone/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества аналоговых трубок.
   * Метод доступен для: admin, service, owner, employee, bti, ltp_first
   */
  GetCmsPhoneCount = (req?: GetCmsPhoneCountRequestDto, init?: RequestInit): Promise<GetCmsPhoneCountResponseDto> => {
    return fm.request<GetCmsPhoneCountRequestDto, GetCmsPhoneCountResponseDto>(`${this.host}/device/api/v1/cms_phone/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления аналоговой трубки.
   * Метод доступен для: admin, service
   */
  DeleteCmsPhone = (req: DeleteCmsPhoneRequestDto, init?: RequestInit): Promise<DeleteCmsPhoneResponseDto> => {
    return fm.request<DeleteCmsPhoneRequestDto, DeleteCmsPhoneResponseDto>(`${this.host}/device/api/v1/cms_phone/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления аналоговой трубки по идентификатору устройсва.
   * Метод доступен для: admin, service
   */
  DeleteCmsPhoneDeviceId = (req: DeleteCmsPhoneDeviceIdRequestDto, init?: RequestInit): Promise<DeleteCmsPhoneDeviceIdResponseDto> => {
    return fm.request<DeleteCmsPhoneDeviceIdRequestDto, DeleteCmsPhoneDeviceIdResponseDto>(`${this.host}/device/api/v1/cms_phone/device_id/${encodeURIComponent(req.deviceId)}${fm.buildQuery(req, ["deviceId"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления аналоговой трубки по идентификатору ОРПОН.
   * Метод доступен для: admin, service
   */
  DeleteCmsPhoneOrponId = (req: DeleteCmsPhoneOrponIdRequestDto, init?: RequestInit): Promise<DeleteCmsPhoneOrponIdResponseDto> => {
    return fm.request<DeleteCmsPhoneOrponIdRequestDto, DeleteCmsPhoneOrponIdResponseDto>(`${this.host}/device/api/v1/cms_phone/orpon_id/${encodeURIComponent(req.orponId)}${fm.buildQuery(req, ["orponId"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления аналоговой трубки по идентификатору ОРПОН и номеру квартиры.
   * Метод доступен для: admin, service
   */
  DeleteCmsPhoneOrponIdRoomNumber = (req: DeleteCmsPhoneOrponIdRoomNumberRequestDto, init?: RequestInit): Promise<DeleteCmsPhoneOrponIdRoomNumberResponseDto> => {
    return fm.request<DeleteCmsPhoneOrponIdRoomNumberRequestDto, DeleteCmsPhoneOrponIdRoomNumberResponseDto>(`${this.host}/device/api/v1/cms_phone/orpon_id/${encodeURIComponent(req.orponId)}/room_number/${encodeURIComponent(req.roomNumber)}${fm.buildQuery(req, ["orponId","roomNumber"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод для принудительного обновления статуса аналоговых трубок.
   * Метод доступен для: admin, service, bti, ltp_first
   */
  PostCmsPhoneRefresh = (req: PostCmsPhoneRefreshRequestDto, init?: RequestInit): Promise<PostCmsPhoneRefreshResponseDto> => {
    return fm.request<PostCmsPhoneRefreshRequestDto, PostCmsPhoneRefreshResponseDto>(`${this.host}/device/api/v1/cms_phone/refresh`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления аналоговой трубки по идентификатору ОРПОН, номеру квартиры и идентификатору устройства.
   * Метод доступен для: admin, service
   */
  DeleteCmsPhoneOrponRoomNumberDeviceId = (req: DeleteCmsPhoneOrponRoomNumberDeviceIdRequestDto, init?: RequestInit): Promise<DeleteCmsPhoneOrponRoomNumberDeviceIdResponseDto> => {
    return fm.request<DeleteCmsPhoneOrponRoomNumberDeviceIdRequestDto, DeleteCmsPhoneOrponRoomNumberDeviceIdResponseDto>(`${this.host}/device/api/v1/cms_phone/orpon/${encodeURIComponent(req.orpon)}/room_number/${encodeURIComponent(req.roomNumber)}/device_id/${encodeURIComponent(req.deviceId)}${fm.buildQuery(req, ["orpon","roomNumber","deviceId"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник статусов аналоговой трубки.
 */
export enum CmsPhoneStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Ожидает активации
   */
  PENDING_ACTIVE = "PENDING_ACTIVE",
  /**
   * Активна
   */
  ACTIVE = "ACTIVE",
  /**
   * Ожидает блокировки
   */
  PENDING_BLOCKED = "PENDING_BLOCKED",
  /**
   * Заблокирована
   */
  BLOCKED = "BLOCKED",
}
/**
 * Справочник статусов аналоговой трубки.
 */
export type CmsPhoneStatusTypeResponseEnum = keyof typeof CmsPhoneStatusType
/**
 * Справочник статусов аналоговой трубки.
 */
export type CmsPhoneStatusTypeRequestEnum = Exclude<CmsPhoneStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки;
 */
export enum CmsPhonePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки;
 */
export type CmsPhonePagingDirectionTypeResponseEnum = keyof typeof CmsPhonePagingDirectionType
/**
 * Справочник типов направлений сортировки;
 */
export type CmsPhonePagingDirectionTypeRequestEnum = Exclude<CmsPhonePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum CmsPhonePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По статусу доступности
   */
  STATUS = "STATUS",
  /**
   * Дата последнего изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * Дата создания
   */
  CREATED_AT = "CREATED_AT",
}
/**
 * Справочник типов значений сортировки.
 */
export type CmsPhonePagingOrderByTypeResponseEnum = keyof typeof CmsPhonePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type CmsPhonePagingOrderByTypeRequestEnum = Exclude<CmsPhonePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Аналоговая трубка.
 * # Описание модели
 */
export type CmsPhoneRequestDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id?: number
  /**
   * ОРПОН Дома.
   * # Диапазон: 0..2147483647
   */
  orponId: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..5
   */
  room: string
  /**
   * Идентификатор устройства.
   * # Диапазон: 0..2147483647
   */
  deviceId: number
  /**
   * Статус аналоговой трубки
   */
  statusType: CmsPhoneStatusTypeRequestEnum
  /**
   * Счетчик попыток обновления.
   * # Диапазон: 0..2147483647
   */
  retryCount: number
}
/**
 * Аналоговая трубка.
 * # Описание модели
 */
export type CmsPhoneResponseDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id: number
  /**
   * ОРПОН Дома.
   * # Диапазон: 0..2147483647
   */
  orponId: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..5
   */
  room: string
  /**
   * Идентификатор устройства.
   * # Диапазон: 0..2147483647
   */
  deviceId: number
  /**
   * Статус аналоговой трубки
   */
  statusType: CmsPhoneStatusTypeResponseEnum
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  readonly changedAt: string
  /**
   * Счетчик попыток обновления.
   * # Диапазон: 0..2147483647
   */
  retryCount: number
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type CmsPhoneSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: CmsPhoneSavingErrorConflictRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type CmsPhoneSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: CmsPhoneSavingErrorConflictResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at оличаются
 */
export type CmsPhoneSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at оличаются
 */
export type CmsPhoneSavingErrorConflictResponseDto = {
}
/**
 * Фильтр по аналоговой трубким
 */
export type CmsPhoneFilterRequestDto = {
  /**
   * По идентификаторам устройства
   */
  deviceIds?: number[]
  /**
   * По статусам аналоговой трубки
   */
  statusTypes?: CmsPhoneStatusTypeResponseEnum[]
  /**
   * По идентификаторам ОРПОН (дома)
   */
  orponIds?: string[]
  /**
   * По номерам квартиры
   */
  rooms?: string[]
}
/**
 * Фильтр по аналоговой трубким
 */
export type CmsPhoneFilterResponseDto = {
  /**
   * По идентификаторам устройства
   */
  deviceIds: number[]
  /**
   * По статусам аналоговой трубки
   */
  statusTypes: CmsPhoneStatusTypeResponseEnum[]
  /**
   * По идентификаторам ОРПОН (дома)
   */
  orponIds: string[]
  /**
   * По номерам квартиры
   */
  rooms: string[]
}
/**
 * Постраничный вывод
 */
export type CmsPhonePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: CmsPhonePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: CmsPhonePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type CmsPhonePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: CmsPhonePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: CmsPhonePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос удаления аналоговых трубок по идентификатору устройства
 */
export type DeleteCmsPhoneDeviceIdRequestDto = {
  /**
   * Идентификатор устройства
   */
  deviceId: number
}
/**
 * Ответ на запрос удаления аналоговых трубок по идентификатору устройства
 */
export type DeleteCmsPhoneDeviceIdResponseDto = {
}
/**
 * Запрос удаления аналоговых трубок по идентификатору ОРПОН
 */
export type DeleteCmsPhoneOrponIdRequestDto = {
  /**
   * Идентификатор ОРПОН
   */
  orponId: string
}
/**
 * Ответ на запрос удаления аналоговых трубок по идентификатору ОРПОН
 */
export type DeleteCmsPhoneOrponIdResponseDto = {
}
/**
 * Запрос удаления аналоговых трубок по идентификатору ОРПОН и номеру квартиры
 */
export type DeleteCmsPhoneOrponIdRoomNumberRequestDto = {
  /**
   * Идентификатор ОРПОН
   */
  orponId: string
  /**
   * Номер квартиры
   */
  roomNumber: string
}
/**
 * Ответ на запрос удаления аналоговых трубок по идентификатору ОРПОН и номеру квартиры
 */
export type DeleteCmsPhoneOrponIdRoomNumberResponseDto = {
}
/**
 * Запрос удаления аналоговых трубок по идентификатору ОРПОН, номеру квартиры и идентификатору устройства
 */
export type DeleteCmsPhoneOrponRoomNumberDeviceIdRequestDto = {
  /**
   * Идентификатор ОРПОН
   */
  orpon: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
}
/**
 * Ответ на запрос удаления аналоговых трубок по идентификатору ОРПОН, номеру квартиры и идентификатору устройства
 */
export type DeleteCmsPhoneOrponRoomNumberDeviceIdResponseDto = {
}
/**
 * Запрос удаления аналоговой трубки
 */
export type DeleteCmsPhoneRequestDto = {
  /**
   * Идентификатор аналоговой трубки
   */
  id: number
}
/**
 * Ответ на запрос удаления аналоговой трубки
 */
export type DeleteCmsPhoneResponseDto = {
}
/**
 * Запрос получения количества аналоговых трубок
 */
export type GetCmsPhoneCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: CmsPhoneFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества аналоговых трубок
 */
export type GetCmsPhoneCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего устройтсв
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetCmsPhoneCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества аналоговых трубок
 */
export type GetCmsPhoneCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества аналоговых трубок
 */
export type GetCmsPhoneCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение списка аналоговых трубок
 */
export type GetCmsPhoneListRequestDto = {
  /**
   * Фильтр
   */
  filter?: CmsPhoneFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: CmsPhonePagingRequestDto
}>
/**
 * Ответ на получение списка аналоговых трубок
 */
export type GetCmsPhoneListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пресет
   */
  readonly data: CmsPhoneResponseDto
  /**
   * Ошибка
   */
  readonly error: GetCmsPhoneListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка аналоговых трубок
 */
export type GetCmsPhoneListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка аналоговых трубок
 */
export type GetCmsPhoneListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения аналоговой трубки
 */
export type GetCmsPhoneRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос получения аналоговой трубки
 */
export type GetCmsPhoneResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Аналоговая трубка
   */
  readonly data: CmsPhoneResponseDto
  /**
   * Ошибка
   */
  readonly error: GetCmsPhoneResponseErrorDto
}>
/**
 * Ошибка запроса получения баннера
 */
export type GetCmsPhoneResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения баннера
 */
export type GetCmsPhoneResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorResponseDto
}>
/**
 * Запрос на принудительное обновление статуса аналоговой трубки
 */
export type PostCmsPhoneRefreshRequestDto = {
  /**
   * Идентификатор
   */
  ids: number[]
}
/**
 * Ответ на запрос на принудительное обновление статуса аналоговой трубки
 */
export type PostCmsPhoneRefreshResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Аналоговая трубка.
   * # Описание модели
   */
  "CmsPhone": {
    "kind": "class",
    "text": "Аналоговая трубка.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * ОРПОН Дома.
       * # Диапазон: 0..2147483647
       */
      "orponId": {
        "type": "int64",
        "text": "ОРПОН Дома.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Номер квартиры.
       * # Диапазон: 1..5
       */
      "room": {
        "type": "string",
        "text": "Номер квартиры.\n# Диапазон: 1..5",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Максимум: 5"
          },
        }
      },
      /**
       * Идентификатор устройства.
       * # Диапазон: 0..2147483647
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Статус аналоговой трубки
       */
      "statusType": {
        "type": "CmsPhone.StatusType",
        "text": "Статус аналоговой трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
      /**
       * Счетчик попыток обновления.
       * # Диапазон: 0..2147483647
       */
      "retryCount": {
        "type": "int32",
        "text": "Счетчик попыток обновления.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "CmsPhone.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "CmsPhone.SavingError.Conflict",
        "text": "Конфликт версий",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at оличаются
   */
  "CmsPhone.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at оличаются",
  },
  /**
   * Фильтр по аналоговой трубким
   */
  "CmsPhoneFilter": {
    "kind": "class",
    "text": "Фильтр по аналоговой трубким",
    "fields": {
      /**
       * По идентификаторам устройства
       */
      "deviceIds": {
        "type": "int32",
        "text": "По идентификаторам устройства",
      },
      /**
       * По статусам аналоговой трубки
       */
      "statusTypes": {
        "type": "CmsPhone.StatusType",
        "text": "По статусам аналоговой трубки",
      },
      /**
       * По идентификаторам ОРПОН (дома)
       */
      "orponIds": {
        "type": "int64",
        "text": "По идентификаторам ОРПОН (дома)",
      },
      /**
       * По номерам квартиры
       */
      "rooms": {
        "type": "string",
        "text": "По номерам квартиры",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "CmsPhonePaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "CmsPhonePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "CmsPhonePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос удаления аналоговых трубок по идентификатору устройства
   */
  "DeleteCmsPhoneDeviceIdRequest": {
    "kind": "class",
    "text": "Запрос удаления аналоговых трубок по идентификатору устройства",
    "fields": {
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления аналоговых трубок по идентификатору устройства
   */
  "DeleteCmsPhoneDeviceIdResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления аналоговых трубок по идентификатору устройства",
  },
  /**
   * Запрос удаления аналоговых трубок по идентификатору ОРПОН
   */
  "DeleteCmsPhoneOrponIdRequest": {
    "kind": "class",
    "text": "Запрос удаления аналоговых трубок по идентификатору ОРПОН",
    "fields": {
      /**
       * Идентификатор ОРПОН
       */
      "orponId": {
        "type": "int64",
        "text": "Идентификатор ОРПОН",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления аналоговых трубок по идентификатору ОРПОН
   */
  "DeleteCmsPhoneOrponIdResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления аналоговых трубок по идентификатору ОРПОН",
  },
  /**
   * Запрос удаления аналоговых трубок по идентификатору ОРПОН и номеру квартиры
   */
  "DeleteCmsPhoneOrponIdRoomNumberRequest": {
    "kind": "class",
    "text": "Запрос удаления аналоговых трубок по идентификатору ОРПОН и номеру квартиры",
    "fields": {
      /**
       * Идентификатор ОРПОН
       */
      "orponId": {
        "type": "int64",
        "text": "Идентификатор ОРПОН",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления аналоговых трубок по идентификатору ОРПОН и номеру квартиры
   */
  "DeleteCmsPhoneOrponIdRoomNumberResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления аналоговых трубок по идентификатору ОРПОН и номеру квартиры",
  },
  /**
   * Запрос удаления аналоговых трубок по идентификатору ОРПОН, номеру квартиры и идентификатору устройства
   */
  "DeleteCmsPhoneOrponRoomNumberDeviceIdRequest": {
    "kind": "class",
    "text": "Запрос удаления аналоговых трубок по идентификатору ОРПОН, номеру квартиры и идентификатору устройства",
    "fields": {
      /**
       * Идентификатор ОРПОН
       */
      "orpon": {
        "type": "int64",
        "text": "Идентификатор ОРПОН",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления аналоговых трубок по идентификатору ОРПОН, номеру квартиры и идентификатору устройства
   */
  "DeleteCmsPhoneOrponRoomNumberDeviceIdResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления аналоговых трубок по идентификатору ОРПОН, номеру квартиры и идентификатору устройства",
  },
  /**
   * Запрос удаления аналоговой трубки
   */
  "DeleteCmsPhoneRequest": {
    "kind": "class",
    "text": "Запрос удаления аналоговой трубки",
    "fields": {
      /**
       * Идентификатор аналоговой трубки
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор аналоговой трубки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления аналоговой трубки
   */
  "DeleteCmsPhoneResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления аналоговой трубки",
  },
  /**
   * Запрос получения количества аналоговых трубок
   */
  "GetCmsPhoneCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества аналоговых трубок",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "CmsPhoneFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества аналоговых трубок
   */
  "GetCmsPhoneCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества аналоговых трубок",
    "fields": {
      /**
       * Всего устройтсв
       */
      "data": {
        "type": "int32",
        "text": "Всего устройтсв",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCmsPhoneCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества аналоговых трубок
   */
  "GetCmsPhoneCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества аналоговых трубок",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение списка аналоговых трубок
   */
  "GetCmsPhoneListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка аналоговых трубок",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "CmsPhoneFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "CmsPhonePaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на получение списка аналоговых трубок
   */
  "GetCmsPhoneListResponse": {
    "kind": "class",
    "text": "Ответ на получение списка аналоговых трубок",
    "fields": {
      /**
       * Пресет
       */
      "data": {
        "type": "CmsPhone",
        "text": "Пресет",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCmsPhoneListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка аналоговых трубок
   */
  "GetCmsPhoneListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка аналоговых трубок",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения аналоговой трубки
   */
  "GetCmsPhoneRequest": {
    "kind": "class",
    "text": "Запрос получения аналоговой трубки",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения аналоговой трубки
   */
  "GetCmsPhoneResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения аналоговой трубки",
    "fields": {
      /**
       * Аналоговая трубка
       */
      "data": {
        "type": "CmsPhone",
        "text": "Аналоговая трубка",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCmsPhoneResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения баннера
   */
  "GetCmsPhoneResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения баннера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на принудительное обновление статуса аналоговой трубки
   */
  "PostCmsPhoneRefreshRequest": {
    "kind": "class",
    "text": "Запрос на принудительное обновление статуса аналоговой трубки",
    "fields": {
      /**
       * Идентификатор
       */
      "ids": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на принудительное обновление статуса аналоговой трубки
   */
  "PostCmsPhoneRefreshResponse": {
    "kind": "class",
    "text": "Ответ на запрос на принудительное обновление статуса аналоговой трубки",
  },
  /**
   * Справочник статусов аналоговой трубки.
   */
  "CmsPhone.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов аналоговой трубки.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Ожидает активации
       */
      "PENDING_ACTIVE": {
        "i": 1,
        "text": "Ожидает активации",
      },
      /**
       * Активна
       */
      "ACTIVE": {
        "i": 2,
        "text": "Активна",
      },
      /**
       * Ожидает блокировки
       */
      "PENDING_BLOCKED": {
        "i": 3,
        "text": "Ожидает блокировки",
      },
      /**
       * Заблокирована
       */
      "BLOCKED": {
        "i": 4,
        "text": "Заблокирована",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки;
   */
  "CmsPhonePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки;",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "CmsPhonePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По статусу доступности
       */
      "STATUS": {
        "i": 2,
        "text": "По статусу доступности",
      },
      /**
       * Дата последнего изменения
       */
      "CHANGED_AT": {
        "i": 3,
        "text": "Дата последнего изменения",
      },
      /**
       * Дата создания
       */
      "CREATED_AT": {
        "i": 4,
        "text": "Дата создания",
      },
    },
  },
}